import { __spreadArrays } from "tslib";
import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common/index';
import { Checkbox } from '../../primitives/checkbox/checkbox';
import { Button } from '../../new-libby/core/button';
import { Popover } from '../../primitives/popover/popover';
import { Icon } from '../../primitives/icon/icon';
import { chevronBoldDown, globus } from '../../icons';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { Text } from '../../new-libby';
export var LocalesPicker = function (props) {
    var classNames = namespacedClassnames(compKey, props.className);
    var organizedLocales = React.useMemo(function () {
        var sortedLocales = props.locales.sort(function (a, b) { return props.localesT(a).localeCompare(props.localesT(b)); });
        var noPrimary = sortedLocales.filter(function (loc) { return loc !== props.primaryLocale; });
        return __spreadArrays([props.primaryLocale], noPrimary);
    }, []);
    var _a = React.useState(false), menuOpen = _a[0], setMenuOpen = _a[1];
    var toggleLocalesMenu = function () { return setMenuOpen(!menuOpen); };
    var _b = React.useState(props.value.length === 0), allLocales = _b[0], setAllLocales = _b[1];
    var _c = React.useState(props.value), selectedLocales = _c[0], setSelectedLocales = _c[1];
    var onCancel = function () {
        setAllLocales(props.value.length === 0);
        setSelectedLocales(props.value);
        toggleLocalesMenu();
    };
    var onApply = function () {
        var localesToApply = allLocales ? [] : selectedLocales;
        props.onChange(localesToApply);
        toggleLocalesMenu();
    };
    var selectAllLocales = function (val) {
        setAllLocales(val);
        if (!val) {
            setSelectedLocales([props.primaryLocale]);
        }
    };
    var primaryLocaleLabel = React.useCallback(function () {
        return (React.createElement("div", { className: namespacedClassnames('primary-locale-item') },
            props.localesT(props.primaryLocale),
            React.createElement(Text, { className: namespacedClassnames('primary-locale-label'), color: allLocales ? 't50' : 't40', type: 'hxs' },
                "(", "" + props.t('common.locale.primary'),
                ")")));
    }, [allLocales]);
    var selectLocale = function (locale) { return function (val, e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        var newSelectedLocales = val ? __spreadArrays(selectedLocales, [locale]) : selectedLocales.filter(function (loc) { return loc !== locale; });
        setSelectedLocales(newSelectedLocales);
    }; };
    React.useEffect(function () {
        var allLocalesAreSelected = props.locales.every(function (l) { return selectedLocales.includes(l); });
        if (allLocalesAreSelected) {
            setAllLocales(true);
        }
    }, [selectedLocales]);
    var localesCheckbox = organizedLocales.map(function (locale) {
        var value = allLocales || selectedLocales.includes(locale);
        return (React.createElement(Checkbox, { className: namespacedClassnames('locales-checkbox'), value: value, disabled: allLocales, onChange: selectLocale(locale) }, props.primaryLocale === locale ? primaryLocaleLabel() : props.localesT(locale)));
    });
    var applyDisabled = !allLocales && selectedLocales.length === 0 ? props.t('common.locale.apply-disabled') : undefined;
    var localeMenu = (React.createElement("div", { className: namespacedClassnames('locales-menu-wrapper') },
        React.createElement(Checkbox, { className: namespacedClassnames('all-locales-checkbox'), value: allLocales, onChange: selectAllLocales }, props.localesT('')),
        React.createElement("div", { className: namespacedClassnames('locales-divider') }),
        React.createElement("div", { className: namespacedClassnames('locales-checkboxes') }, localesCheckbox),
        React.createElement("div", { className: namespacedClassnames('locale-picker-footer') },
            React.createElement(Button, { type: 'secondary', onClick: onCancel }, props.t('common.cancel')),
            React.createElement(Button, { disabled: applyDisabled, onClick: onApply }, props.t('common.apply')))));
    var getSelectedLocale = function () {
        if (props.value.length === 1) {
            return props.value[0].toLocaleUpperCase();
        }
        if (props.value.length > 1) {
            var tooltipBody = props.value.map(function (loc) { return props.localesT(loc); }).join(', ');
            return (React.createElement(Tooltip, { className: 'multiple-locales-tooltip', body: tooltipBody, relativeToBody: true }, props.value[0].toLocaleUpperCase() + "+" + (props.value.length - 1)));
        }
        return props.t('common.all');
    };
    return (React.createElement("div", { className: classNames },
        React.createElement(Popover, { body: localeMenu, isOpen: menuOpen, onOuterAction: toggleLocalesMenu },
            React.createElement(Button, { type: 'tertiary', className: namespacedClassnames('picked-locale-wrapper'), onClick: toggleLocalesMenu },
                React.createElement(Icon, { className: 'globus-icon', icon: globus }),
                React.createElement("span", { className: namespacedClassnames('picked-locales'), "data-value": props.value }, getSelectedLocale()),
                React.createElement(Icon, { className: 'dd-icon', icon: chevronBoldDown })))));
};
//# sourceMappingURL=index.js.map